import { useTranslation } from 'react-i18next'
import { FaBars, FaHome, FaSearchengin } from 'react-icons/fa'
import { FaRegCalendarCheck } from 'react-icons/fa6'

import { useContextualPath } from '@/hooks/useContextualPath'
import { PoolingRoutes, StaticPagesRoutes } from '@/routes/_hooks/routes.enum'

export interface MobileBottomNavItem {
  key: string
  label: string
  icon: React.ComponentType<{ size?: number }>
  to?: string
  /** When true, this tab opens the menu drawer instead of navigating. */
  isMenu?: boolean
  /** Predicate to decide the active state from the current pathname. */
  match?: (pathname: string) => boolean
}

/**
 * The four stable bottom-bar tabs (the central "Ajouter" FAB is rendered
 * separately by `MobileBottomNav`). Order: Accueil · Recherche · [FAB] ·
 * Réservations · Menu. The Réservations target is context-aware (personal vs
 * community/network) via `useContextualPath`.
 */
export const useMobileBottomNav = (): MobileBottomNavItem[] => {
  const { t } = useTranslation()
  const { generateContextualPath } = useContextualPath()

  return [
    {
      key: 'home',
      label: t('layout.mobileBottomNav.home'),
      icon: FaHome,
      to: StaticPagesRoutes.Home,
      match: (pathname) => pathname === StaticPagesRoutes.Home,
    },
    {
      key: 'search',
      label: t('layout.mobileBottomNav.search'),
      icon: FaSearchengin,
      to: PoolingRoutes.Search,
      match: (pathname) =>
        pathname.startsWith(PoolingRoutes.Search) &&
        pathname !== PoolingRoutes.New,
    },
    {
      key: 'reservations',
      label: t('layout.mobileBottomNav.reservations'),
      icon: FaRegCalendarCheck,
      to: generateContextualPath('bookingsAsOwner'),
      match: (pathname) => pathname.includes('/bookings'),
    },
    {
      key: 'menu',
      label: t('layout.mobileBottomNav.menu'),
      icon: FaBars,
      isMenu: true,
    },
  ]
}
